import { request } from './utils';

export default class ReportService {
    static async dailyProcessingReport(fromDate, toDate, selectedRecords) {
        const response = await request('/admin/reports/daily-processing', {
            method: 'POST',
            data: {
                fromDate,
                toDate,
                selectedRecords
            }
        });

        return response;
    }
}
